/*
#FFFFFF
#F7F6FC
#F0EEF9
#E3DFF5
#CDC5ED
#B3A4E1
#977FD3
#8B6BC7
#7451B0
#614394
#51387A
#332352
*/

export const sapphire = {
  sapphire0: '#FFFFFF', // 255, 255, 255
  sapphire1: '#F7F6FC', // 247, 246, 252
  sapphire2: '#F0EEF9', // 240, 238, 249
  sapphire3: '#E3DFF5', // 227, 223, 245
  sapphire4: '#CDC5ED', // 205, 197, 237
  sapphire5: '#B3A4E1', // 179, 164, 225
  sapphire6: '#977FD3', // 151, 127, 211 *
  sapphire7: '#8B6BC7', // 139, 107, 199
  sapphire8: '#7451B0', // 116, 81, 176
  sapphire9: '#614394', // 97, 67, 148
  sapphire10: '#51387A', // 81, 56, 122
  sapphire11: '#332352', // 51, 35, 82
  sapphire12: '#332352', // 51, 35, 82
} as const;

export const sapphireDark = {
  sapphire0: '#120d1a',
  sapphire1: '#20182d',
  sapphire2: '#2d2241',
  sapphire3: '#232a39',
  sapphire4: '#363c5b',
  sapphire5: '#4a497e',
  sapphire6: '#675aa2',
  sapphire7: '#8b6bc7',
  sapphire8: '#8b81d2',
  sapphire9: '#989fdb',
  sapphire10: '#afc0e5',
  sapphire11: '#c7dcee',
  sapphire12: '#e0f1f6',
} as const;

/**
 *
 *
 * Archives.
 *
 * sapphire0: '#e0f1f6',
 * sapphire1: '#c7dcee',
 * sapphire2: '#afc0e5',
 * sapphire3: '#989fdb',
 * sapphire4: '#8b81d2',
 * sapphire5: '#8b6bc7',
 * sapphire6: '#675aa2',
 * sapphire7: '#4a497e',
 * sapphire8: '#363c5b',
 * sapphire9: '#232a39',
 * sapphire10: '#2d2241',
 * sapphire11: '#20182d',
 * sapphire12: '#120d1a',
 */
